<template>
  <pt-goods-manage class="pt-goods-manage__withData" @goodsDelete="goodsDelete" @setStick="setStick" @cancelStick="cancelStick"
  ref="goodsList" @goodsRecommend="goodsRecommend" @applyForApproval="applyForApproval" @getGoodsGroup="getGoodsGroup"
  :group-list="groupList" :goodsTypeList="goodsTypeList" :vendorsOrganizations="vendorsOrganizations"></pt-goods-manage>
</template>

<script>
import PtGoodsManage from './index'
export default {
  name: 'pt-goods-manage__withData',
  components: {
    'pt-goods-manage': PtGoodsManage
  },
  data () {
    return {
      groupList: [],
      goodsTypeList: [],
      vendorsOrganizations: []
    }
  },
  methods: {
    // 获取第三方供应商列表
    getVendorsOrganizations () {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getVendorsOrganizations', data).then(res => {
        this.vendorsOrganizations = res
      }).catch(err => {
        this.$message.error(err || '获取第三方供应商列表失败')
      })
    },
    goodsDelete (id) {
      this.$store.dispatch('goodsDelete', id).then(res => {
        this.$refs.goodsList.goods_list()
      }).catch(err => {
        this.$message.error(err || '删除商品失败')
      })
    },
    setStick (val) {
      this.$store.dispatch('setStick', val.goodsDTO.id).then(res => {
        val.goodsOtherInfoDTO.sticky = true
        this.$message.success('置顶商品成功')
      }).catch(err => {
        this.$message.error(err || '置顶商品失败')
      })
    },
    cancelStick (val) {
      this.$store.dispatch('cancelStick', val.goodsDTO.id).then(res => {
        val.goodsOtherInfoDTO.sticky = false
        this.$message.success('取消商品置顶成功')
      }).catch(err => {
        this.$message.error(err || '取消商品置顶失败')
      })
    },
    getGoodsRecommend (val) {
      this.$store.dispatch('goodsRecommend', val.goodsDTO.id).then(res => {
        val.goodsOtherInfoDTO.recommend = true
      }).catch(err => {
        this.$message.error(err || '推荐商品失败')
      })
    },
    applyForApproval (id) {
      this.$store.dispatch('applyForApproval', id).then(res => {
        this.$refs.goodsList.goods_list()
      }).catch(err => {
        this.$message.error(err || '提交商品审核失败')
      })
    },
    getGoodsRecommendCancel (val) {
      this.$store.dispatch('goodsRecommendCancel', val.goodsDTO.id).then(res => {
        val.goodsOtherInfoDTO.recommend = false
      }).catch(err => {
        this.$message.error(err || '获取商品详情失败')
      })
    },
    goodsRecommend (val) {
      if (val.goodsOtherInfoDTO.recommend) {
        this.getGoodsRecommendCancel(val)
      } else {
        this.getGoodsRecommend(val)
      }
    },
    getGoodsGroup () {
      let data = {
        example: {},
        pageable: {
          page: 0,
          size: 1000
        }
      }
      if (this.groupType) {
        data.example.type = this.groupType
      }
      this.$store.dispatch('getGoodsGroup', data).then(res => {
        this.groupList = res.data
      }).catch(err => {
        this.$message.error(err || '获取商品分组列表失败')
      })
    },
    // 获取商品类型列表
    getGoodsTypes () {
      this.$store.dispatch('getGoodsTypes').then(res => {
        this.goodsTypeList = res
      }).catch(err => {
        this.$message.error(err || '获取商品类型失败')
      })
    }
  },
  created () {
    this.getGoodsTypes()
    this.getVendorsOrganizations()
  }
}
</script>
